module.exports = __webpack_public_path__ + "web21.png?70717f1b9f23ae08fc5d5e9c2145797b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/web21.png
// module id = 69
// module chunks = 0